window.smartrrAccountConfig = {
    navigationBarCreatedCallback: (e) => {
          console.log("Data: ", {element: e});
          if (!e) return;
          var $ul = e.querySelector('ul');
          if (!$ul) return;
          var newli = document.createElement('li');
          newli.innerHTML = `<a class="smartrr-portal-navbar-login" href="https://shopify.com/55920263252/account/profile">Payment Methods</a>`;
          $ul.prepend(newli);
    }
}